import { useQuery } from "@tanstack/react-query";
import QueryGlobalInterface from "interfaces/queryInterface";
import { toast } from "react-toastify";
import instance from "services/axiosServices";

interface ListarPDVProps extends QueryGlobalInterface {
  enabled?: boolean;
}

export function useListarPDV(props: ListarPDVProps) {
  const fetchData = async () => {
    const LISTAR_PDV = `/locais/common/plantao-vendas/v1?`;
    const response = await instance.get(LISTAR_PDV);

    return response?.data || null;
  };

  const query = useQuery({
    queryFn: () => fetchData(),
    queryKey: [props.queryKey],
    refetchOnWindowFocus: false,
    enabled: props.enabled !== undefined ? props.enabled : false,
    onError: (error: any) => {
      toast?.error(
        `Erro ao listar PDV. ${error?.response?.data?.notifications?.map(
          (item: any) => item?.message ?? ""
        )} `,
        { autoClose: 10000 }
      );
    },
  });

  return query;
}
